import React from "react";
import {Box, Colors} from "@bounce/shared/ui";

const TOGGLE_HEIGHT = 36;

type Option<T extends string> = {value: T; label: string};

type Props<T extends string> = {
  value: T;
  options: Option<T>[];
  onChange: (next: T) => void;
};

const SegmentedToggle = <T extends string>({value, options, onChange}: Props<T>) => (
  <Box
    sx={{
      display: "inline-flex",
      gap: 0.5,
      backgroundColor: Colors.tertiary._200,
      borderRadius: "8px",
      height: TOGGLE_HEIGHT,
      p: "3px",
    }}
  >
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <Box
          key={option.value}
          component="button"
          type="button"
          onClick={() => onChange(option.value)}
          sx={{
            border: 0,
            px: 1.5,
            borderRadius: "6px",
            fontSize: 13,
            fontFamily: "inherit",
            fontWeight: selected ? 600 : 400,
            color: selected ? Colors.grey._900 : Colors.grey._600,
            backgroundColor: selected ? Colors.bw.white : "transparent",
            boxShadow: selected ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
            cursor: "pointer",
          }}
        >
          {option.label}
        </Box>
      );
    })}
  </Box>
);

export default SegmentedToggle;
